<!-- Overlay -->
<div class="fixed inset-0 bg-black/60 backdrop-blur-sm z-[999999]" (click)="closeForm()"></div>

<!-- Modal (desktop centrado) / Bottom sheet (mobile) -->
<div (click)="$event.stopPropagation()" [ngClass]="isMobileView()
    ? 'fixed bottom-0 inset-x-0 rounded-t-[28px] h-[92%] flex flex-col z-[999999]'
    : 'fixed inset-0 m-auto w-[460px] max-h-[90vh] h-fit rounded-[24px] flex flex-col z-[999999]'"
  class="bg-white dark:bg-dark-secondary shadow-xl overflow-hidden">

  <!-- Mobile drag handle -->
  <div *ngIf="isMobileView()" class="pt-3 pb-1 flex justify-center shrink-0">
    <span class="w-9 h-1 rounded-full bg-gray-200 dark:bg-dark-border opacity-60"></span>
  </div>

  <!-- Header -->
  <div class="px-5 pt-5 pb-4 flex items-start justify-between shrink-0">
    <div>
      <h2 class="text-[17px] font-bold tracking-tight text-gray-900 dark:text-dark-text">{{ formTitle }}</h2>
      <p class="text-xs text-gray-500 dark:text-dark-muted mt-0.5">
        <ng-container *ngIf="activeGroup && !isEditing && !isIncome">
          {{ TEXT.TRANSACTIONS.SUBTITLE_GROUP }} <strong>{{ activeGroup.name }}</strong>
        </ng-container>
        <ng-container *ngIf="!activeGroup || isEditing || isIncome">
          {{ isEditing ? TEXT.TRANSACTIONS.SUBTITLE_EDIT : TEXT.TRANSACTIONS.SUBTITLE_NEW }}
        </ng-container>
      </p>
    </div>
    <button type="button" (click)="closeForm()"
      class="w-8 h-8 rounded-full hover:bg-gray-100 dark:hover:bg-dark-tertiary text-gray-400 dark:text-dark-muted inline-flex items-center justify-center shrink-0 transition-colors">
      <span class="material-symbols-rounded text-lg">close</span>
    </button>
  </div>

  <!-- Body -->
  <form [formGroup]="form" class="flex-1 overflow-y-auto px-5 pb-4 space-y-3.5 min-h-0">

    <!-- Cuenta de Mercado Pago (solo al editar una transacción importada) -->
    <mp-counterparty-alias *ngIf="isEditing && editingTransaction?.mp_counterparty_id" class="block"
      [mpCounterpartyId]="editingTransaction?.mp_counterparty_id"></mp-counterparty-alias>

    <!-- ═══════ Bloque IA ═══════ -->
    <div *ngIf="!isEditing && canUsePrompt()" class="section-transition"
      [ngClass]="{ 'section-disabled': activeMode === 'manual' }">
      <div [formGroup]="promptForm" class="ai-block rounded-xl border px-3 py-2.5 space-y-2">
        <div class="flex items-center gap-2">
          <span class="w-7 h-7 rounded-lg bg-yellow-400/15 flex items-center justify-center shrink-0">
            <span class="material-symbols-rounded text-base text-yellow-500">auto_awesome</span>
          </span>
          <div>
            <div class="text-[13px] font-semibold text-gray-900 dark:text-dark-text">{{
              TEXT.TRANSACTIONS.PROMPT_AI_TITLE }}</div>
            <div class="text-[11px] text-gray-500 dark:text-dark-muted">{{ TEXT.TRANSACTIONS.PROMPT_SUBTITLE }}</div>
          </div>
        </div>
        <div class="flex gap-2 items-end">
          <textarea #promptInput formControlName="prompt"
            class="flex-1 px-3 py-2 border border-neutral-border dark:border-dark-border rounded-xl focus:ring-2 focus:ring-brand-primary/40 outline-none resize-none bg-white dark:bg-dark-secondary dark:text-dark-text dark:placeholder:text-dark-muted transition-shadow text-sm"
            rows="2" [placeholder]="TEXT.TRANSACTIONS.PROMPT_PLACEHOLDER" (input)="activatePrompt()"
            (keydown.enter)="$event.preventDefault(); submitForm()"></textarea>
          <button type="button" (click)="submitForm()" [disabled]="!hasPromptText"
            class="h-9 w-9 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors duration-200"
            [ngClass]="hasPromptText
              ? 'bg-yellow-400 text-zinc-900 hover:bg-yellow-300'
              : 'bg-gray-100 dark:bg-dark-tertiary text-gray-400 dark:text-dark-muted cursor-not-allowed'">
            <span class="material-symbols-rounded text-base">arrow_upward</span>
          </button>
        </div>
        <div *ngIf="activeGroup && activeMode === 'prompt'"
          class="text-[11px] text-gray-400 dark:text-dark-muted flex items-center gap-1">
          <span class="material-symbols-rounded text-sm">info</span>
          <span>{{ TEXT.TRANSACTIONS.AI_GROUP_INFO }}</span>
        </div>
      </div>
    </div>

    <!-- Divider "o manual" -->
    <div *ngIf="!isEditing && canUsePrompt()" class="divider-or">
      <span class="divider-or-text">{{ TEXT.TRANSACTIONS.OR_MANUAL }}</span>
    </div>

    <!-- Manual section — dimmed when prompt is active -->
    <div class="space-y-3.5 section-transition" [ngClass]="{ 'section-disabled': activeMode === 'prompt' }">

      <!-- Tipo -->
      <div class="flex items-center justify-between">
        <label class="text-xs font-medium text-gray-600 dark:text-dark-muted">
          {{ TEXT.TRANSACTIONS.TYPE }}<span class="text-brand-primary ml-0.5"></span>
        </label>
        <app-segmented-control [options]="types" [selectedValue]="form.get('type')?.value"
          (valueChange)="onTypeChange($event); activateManual()">
        </app-segmented-control>
      </div>

      <!-- Monto + Moneda -->
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-dark-muted mb-1.5">
          {{ TEXT.TRANSACTIONS.AMOUNT }} <span class="text-brand-primary">*</span>
        </label>
        <div class="flex gap-2">
          <div class="relative flex-1">
            <input #amountInput type="text" formControlName="amount"
              class="w-full h-11 pl-3.5 pr-10 rounded-xl border border-neutral-border dark:border-dark-border bg-neutral-soft dark:bg-dark-tertiary text-sm text-gray-900 dark:text-dark-text placeholder:text-gray-400 dark:placeholder:text-dark-muted outline-none focus:ring-2 focus:ring-brand-primary/40 transition-shadow"
              [placeholder]="TEXT.TRANSACTIONS.PLACEHOLDER_AMOUNT" (input)="activateManual()"
              (keydown.enter)="onAmountEnter($event)" />
            <button type="button" (click)="toggleCalculator()" title="Calculadora"
              class="absolute right-2.5 top-1/2 -translate-y-1/2 transition-colors"
              [ngClass]="showCalculator ? 'text-brand-primary' : 'text-gray-400 dark:text-dark-muted hover:text-gray-600'">
              <span class="material-symbols-rounded text-[18px]">calculate</span>
            </button>
          </div>
          <button type="button" (click)="toggleCurrency()"
            class="h-11 px-2.5 rounded-xl border border-neutral-border dark:border-dark-border bg-neutral-soft dark:bg-dark-tertiary inline-flex items-center gap-1.5 text-xs font-semibold text-gray-700 dark:text-dark-text hover:bg-gray-100 dark:hover:bg-dark-border transition-colors">
            <span [innerHTML]="getSelectedCurrencyFlag() | safeHtml" class="w-4 h-3 inline-block"></span>
            {{ form.get('currency')?.value }}
          </button>
        </div>
        <!-- Calculator operators -->
        <div *ngIf="showCalculator" class="flex gap-1.5 mt-2 animate-slide-down">
          <button *ngFor="let op of calculatorOperators" type="button" (click)="insertOperator(op.value)"
            [ngClass]="op.class"
            class="flex-1 h-9 border border-neutral-border dark:border-dark-border rounded-xl text-sm font-semibold transition-colors">
            {{ op.label }}
          </button>
        </div>
      </div>

      <!-- Categoría + Fecha (2-col) -->
      <div class="grid grid-cols-2 gap-3">
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-dark-muted mb-1.5">
            {{ TEXT.TRANSACTIONS.CATEGORY }} <span class="text-brand-primary">*</span>
          </label>
          <custom-dropdown class="w-full" [items]="categories" [searchable]="true" [selectedValue]="selectedCategoryId"
            [placeholder]="TEXT.TRANSACTIONS.SELECT_CATEGORY" (selectionChange)="onCategoryChange($event)">
          </custom-dropdown>
        </div>
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-dark-muted mb-1.5">
            {{ TEXT.TRANSACTIONS.DATE }}
          </label>
          <div class="relative">
            <span *ngIf="!form.get('date')?.value"
              class="absolute left-3 top-1/2 -translate-y-1/2 material-symbols-rounded text-[17px] text-gray-400 dark:text-dark-muted pointer-events-none">event</span>
            <input type="date" formControlName="date" [class.pl-9]="!form.get('date')?.value"
              [class.pl-3.5]="!!form.get('date')?.value"
              class="w-full h-11 pr-3 rounded-xl border border-neutral-border dark:border-dark-border bg-neutral-soft dark:bg-dark-tertiary text-sm text-gray-900 dark:text-dark-text outline-none focus:ring-2 focus:ring-brand-primary/40 transition-shadow"
              (change)="activateManual()" />
          </div>
        </div>
      </div>

      <!-- Add-ons -->
      <div class="flex flex-col gap-3">
        <!-- ═══════ Add-on: Descripción ═══════ -->
        <description-addon *ngIf="activeAddOns.has('description')" [control]="form.get('description')!"
          [placeholder]="TEXT.TRANSACTIONS.DESCRIPTION" (remove)="removeAddOn('description')"
          (change)="activateManual()">
        </description-addon>

        <!-- ═══════ Add-on: Compartir (sin grupo global activo) ═══════ -->
        <group-share-addon *ngIf="activeAddOns.has('share') && !activeGroup && (!isIncome || comunGroupsOnly.length > 0)"
          [groups]="isIncome ? comunGroupsOnly : allGroupsData"
          [selectedGroupId]="form.get('group_id')?.value || null" [members]="groupMembersList"
          [splitOptions]="SHARE_SPLIT_OPTIONS" [splitType]="splitType" [paidById]="splitPaidById"
          [splitValues]="splitValuesForAddon" [memberSelectedState]="memberSelectedForAddon"
          [showMemberCheckboxes]="true" [initiallyExpanded]="true"
          [defaultGroupId]="defaultGroupId" [totalAmount]="form.get('amount')?.value || 0"
          [generatesDebt]="generatesDebt" [splitOverrideEnabled]="splitOverrideEnabled"
          (groupSelected)="onGroupChange($event); activateManual()" (splitTypeChanged)="onSplitTypeChange($event)"
          (paidByChanged)="splitPaidById = $event" (splitValueChanged)="onShareSplitValueChanged($event)"
          (memberToggled)="onShareMemberToggled($event)" (removed)="removeAddOn('share')"
          (setAsDefault)="onAddonSetAsDefault($event)"
          (generatesDebtChanged)="onGenerateDebtChanged($event)" (splitOverrideToggled)="onSplitOverrideToggled($event)"
          (openIncomeModal)="onOpenIncomeModal()">
        </group-share-addon>

        <!-- Grupo global activo (siempre visible, sin add-on chip) -->
        <div *ngIf="activeGroup && groupMembersList.length > 0 && (!isIncome || activeGroup.division === 'common')"
          class="rounded-xl border border-neutral-border dark:border-dark-border bg-neutral-soft dark:bg-dark-tertiary p-3 space-y-3">
          <div class="flex items-center gap-3">
            <span class="w-7 h-7 rounded-lg bg-info/15 flex items-center justify-center shrink-0">
              <span class="material-symbols-rounded text-base text-info">groups</span>
            </span>
            <span class="flex-1 text-[13px] font-semibold text-gray-900 dark:text-dark-text truncate">{{
              activeGroup.name
              }}</span>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-600 dark:text-dark-muted mb-1.5">
              {{ activeGroup.division === 'common' ? TEXT.TRANSACTIONS.WHO_LOADED_IT : '¿Quién pagó?' }}
            </label>
            <div class="relative">
              <select
                class="w-full h-11 px-3.5 rounded-xl border border-neutral-border dark:border-dark-border bg-white dark:bg-dark-secondary text-sm text-gray-900 dark:text-dark-text outline-none focus:ring-2 focus:ring-brand-primary/40 transition-shadow appearance-none"
                [(ngModel)]="splitPaidById" [ngModelOptions]="{standalone: true}">
                <option *ngFor="let m of groupMembersList" [value]="m.id">{{ m.name }}</option>
              </select>
              <span
                class="material-symbols-rounded absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">expand_more</span>
            </div>
          </div>

          <!-- Todo en común: no se reparte -->
          <p *ngIf="activeGroup.division === 'common'" class="text-[12px] text-gray-400 dark:text-dark-muted px-1">
            {{ isIncome ? 'Ingreso en común' : 'Gasto en común' }} — no genera deuda
          </p>

          <!-- División automática (Según ingresos / Porcentaje fijo) -->
          <div *ngIf="!isIncome && (activeGroup.division === 'income' || activeGroup.division === 'fixed') && !splitOverrideEnabled"
            class="flex items-center justify-between px-1 py-0.5">
            <span class="text-[12px] text-gray-400 dark:text-dark-muted">División automática</span>
            <button type="button" (click)="onSplitOverrideToggled(true)" class="text-[11px] font-medium text-ocean hover:underline">
              {{ TEXT.TRANSACTIONS.OVERRIDE_SPLIT_LABEL }}
            </button>
          </div>

          <!-- Marcar como deuda -->
          <div *ngIf="!isIncome && activeGroup.division !== 'common'" class="flex items-center justify-between px-1 py-1 gap-3">
            <div class="min-w-0">
              <div class="text-[12px] font-medium text-gray-700 dark:text-dark-text">{{ TEXT.TRANSACTIONS.GENERATES_DEBT_LABEL }}</div>
              <div class="text-[11px] text-gray-400 dark:text-dark-muted">
                {{ generatesDebt ? TEXT.TRANSACTIONS.GENERATES_DEBT_HINT_ON : TEXT.TRANSACTIONS.GENERATES_DEBT_HINT_OFF }}
              </div>
            </div>
            <button type="button" role="switch" [attr.aria-checked]="generatesDebt"
              (click)="onGenerateDebtChanged(!generatesDebt)"
              class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ocean"
              [ngClass]="generatesDebt ? 'bg-brand-primary' : 'bg-gray-300 dark:bg-dark-border'">
              <span class="inline-block h-4 w-4 transform rounded-full bg-white transition-transform"
                [ngClass]="generatesDebt ? 'translate-x-6' : 'translate-x-1'"></span>
            </button>
          </div>

          <!-- Tu ingreso -->
          <div *ngIf="activeGroup.division === 'income'" class="px-1 py-0.5">
            <button type="button" (click)="onOpenIncomeModal()" class="text-[11px] font-medium text-ocean hover:underline">
              {{ TEXT.TRANSACTIONS.MY_INCOME_LINK }}
            </button>
          </div>

          <div *ngIf="!isIncome && activeGroup.division !== 'common' && (activeGroup.division !== 'income' && activeGroup.division !== 'fixed' || splitOverrideEnabled)"
            class="flex items-center gap-1 p-1 rounded-full bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border">
            <button *ngFor="let opt of SHARE_SPLIT_OPTIONS" type="button" (click)="onSplitTypeChange(opt.key)"
              class="flex-1 h-7 rounded-full text-[11px] font-medium transition-colors"
              [class.bg-brand-primary]="splitType === opt.key" [class.text-zinc-900]="splitType === opt.key"
              [class.text-gray-500]="splitType !== opt.key" [class.dark:text-dark-muted]="splitType !== opt.key">
              {{ opt.label }}
            </button>
          </div>
          <div *ngIf="isIncome || activeGroup.division === 'common' || ((activeGroup.division !== 'income' && activeGroup.division !== 'fixed') || splitOverrideEnabled)" class="space-y-1">
            <div *ngFor="let m of groupMembersList"
              class="flex items-center gap-2.5 bg-white dark:bg-dark-secondary border border-neutral-border dark:border-dark-border rounded-lg px-2.5 py-1.5">
              <div
                class="w-6 h-6 rounded-full bg-brand-primary/10 text-brand-primary flex items-center justify-center text-[10px] font-semibold shrink-0 uppercase">
                {{ m.name.charAt(0) }}
              </div>
              <div class="flex-1 text-[12px] font-medium text-gray-900 dark:text-dark-text truncate">
                {{ m.name }}<span *ngIf="m.id === splitPaidById" class="text-brand-primary ml-1 text-[10px]">({{
                  TEXT.TRANSACTIONS.PAID_LABEL }})</span>
              </div>
              <div class="w-20 flex justify-end shrink-0" *ngIf="!isIncome && activeGroup.division !== 'common'">
                <div *ngIf="splitType === 'equal'">
                  <button type="button" (click)="toggleSplitSelection(m.id)"
                    class="w-6 h-6 rounded-md border flex items-center justify-center transition-all" [ngClass]="splitsState[m.id].selected
                    ? 'bg-brand-primary border-brand-primary text-white'
                    : 'border-neutral-border dark:border-dark-border bg-white dark:bg-dark-tertiary text-transparent'">
                    <span class="material-symbols-rounded text-sm">check</span>
                  </button>
                </div>
                <div *ngIf="(splitType === 'exact' || splitType === 'percentage') && m.id === splitPaidById"
                  class="text-[12px] font-semibold text-gray-500 dark:text-gray-400">
                  <span *ngIf="splitType === 'exact'">{{ getPaidByRemainingAmount() |
                    currency:form.get('currency')?.value:'symbol-narrow':'1.0-2' }}</span>
                  <span *ngIf="splitType === 'percentage'">{{ getPaidByRemainingPercentage() }}%</span>
                </div>
                <div *ngIf="(splitType === 'exact' || splitType === 'percentage') && m.id !== splitPaidById">
                  <input type="number" min="0" [value]="splitsState[m.id].value"
                    (input)="onSplitValueChange(m.id, $event)"
                    class="w-16 h-6 bg-neutral-soft dark:bg-dark-tertiary border border-neutral-border dark:border-dark-border rounded-md px-1.5 text-[11px] text-right text-gray-900 dark:text-dark-text outline-none"
                    [placeholder]="splitType === 'exact' ? '0.00' : '0'" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ═══════ Add-on: Etiquetas ═══════ -->
        <tags-addon *ngIf="activeAddOns.has('tags')" [initialTags]="tags" [suggestions]="availableTags"
          (tagsChange)="tags = $event" (remove)="removeAddOn('tags')" (change)="activateManual()">
        </tags-addon>

        <!-- ═══════ Add-on chips row ═══════ -->
        <addon-chip-bar [addons]="inactiveAddOns" [addLabel]="TEXT.TRANSACTIONS.ADD_ON_LABEL"
          (activate)="activateAddOn($event)">
        </addon-chip-bar>

      </div><!-- end manual section wrapper -->
    </div>

  </form>

  <!-- Footer -->
  <div
    class="px-5 py-3.5 border-t border-neutral-border dark:border-dark-border flex items-center justify-end gap-2 shrink-0"
    [style.paddingBottom]="isMobileView() ? 'max(0.875rem, env(safe-area-inset-bottom))' : '0.875rem'">
    <button type="button" (click)="closeForm()"
      class="h-10 px-4 rounded-full text-sm font-medium text-gray-500 dark:text-dark-muted hover:text-gray-900 dark:hover:text-dark-text transition-colors">
      {{ TEXT.COMMON.CANCEL }}
    </button>
    <button type="button" (click)="submitForm()" [disabled]="!canSubmit"
      class="h-10 px-5 rounded-full bg-brand-primary text-zinc-900 text-sm font-semibold hover:bg-brand-hover inline-flex items-center gap-1.5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
      <span class="material-symbols-rounded text-base">{{ isEditing ? 'save' : 'add' }}</span>
      {{ submitButtonText }}
    </button>
  </div>

  <income-modal *ngIf="showIncomeModal" (close)="showIncomeModal = false" (saved)="showIncomeModal = false"></income-modal>

</div>